import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const MonitorIcon16 = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke={props.color ?? '#3379BD'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.333 14h5.334M8 11.333V14M2.667 2h10.666c.737 0 1.334.597 1.334 1.333V10c0 .736-.597 1.333-1.333 1.333H2.667A1.333 1.333 0 0 1 1.334 10V3.333C1.333 2.597 1.93 2 2.667 2Z"
    />
  </Svg>
);
export default MonitorIcon16;
